/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListProjectsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListProjectsRequest = {
  /**
   * The ID of the organization to list projects for
   */
  organizationId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListProjectsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListProjectsSecurity$outboundSchema: z.ZodMiniType<
  ListProjectsSecurity$Outbound,
  ListProjectsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listProjectsSecurityToJSON(
  listProjectsSecurity: ListProjectsSecurity,
): string {
  return JSON.stringify(
    ListProjectsSecurity$outboundSchema.parse(listProjectsSecurity),
  );
}

/** @internal */
export type ListProjectsRequest$Outbound = {
  organization_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListProjectsRequest$outboundSchema: z.ZodMiniType<
  ListProjectsRequest$Outbound,
  ListProjectsRequest
> = z.pipe(
  z.object({
    organizationId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      organizationId: "organization_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listProjectsRequestToJSON(
  listProjectsRequest: ListProjectsRequest,
): string {
  return JSON.stringify(
    ListProjectsRequest$outboundSchema.parse(listProjectsRequest),
  );
}
